// docs/specs/foundation/i18n.md: the UI comes in English (default) and Indonesian.
// Same values as the backend's common/i18n/locales.ts.

export const UI_LOCALES = ["en-US", "id-ID"] as const;
export type UiLocale = (typeof UI_LOCALES)[number];
export const DEFAULT_LOCALE: UiLocale = "en-US";
